'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _card_component = require('./global_components/card_component.js');

var _card_component2 = _interopRequireDefault(_card_component);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _functional_utility = require('common-utilities/src/functional_utility');

var _string_utility = require('common-utilities/src/string_utility');

var _string_utility2 = _interopRequireDefault(_string_utility);

var _tracking_utility = require('../../../packages/common-utilities/src/tracking_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PortfolioInsightCard = function (_React$Component) {
  _inherits(PortfolioInsightCard, _React$Component);

  function PortfolioInsightCard(props) {
    _classCallCheck(this, PortfolioInsightCard);

    var _this = _possibleConstructorReturn(this, (PortfolioInsightCard.__proto__ || Object.getPrototypeOf(PortfolioInsightCard)).call(this, props));

    _this.trackGA = _this.trackGA.bind(_this);
    return _this;
  }

  _createClass(PortfolioInsightCard, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _card_component2.default,
        {
          dataTest: this.props.cardId,
          headerTitle: this.props.cardTitle,
          headerTitleId: this.props.cardId + '-title',
          headerTitleLabel: this.props.cardId + '-title',
          headerLabel: "",
          breakpoint: this.props.breakpoint },
        _react2.default.createElement(
          'div',
          { className: 'row' },
          this.renderInsights(this.props.relatedInsights)
        )
      );
    }
  }, {
    key: 'trackGA',
    value: function trackGA(clickUrl) {
      _tracking_utility.TrackingUtility.trackEvent({
        "eventCategory": "pdp",
        "eventAction": 'article: ' + clickUrl,
        "eventLabel": 'from: ' + window.location.href
      });
    }
  }, {
    key: 'renderInsights',
    value: function renderInsights(insights) {
      var self = this;
      return insights.map(function (insight, index) {
        var contributors = "";
        if (!self.props.contributorsInSingleLine) {
          contributors = self.getContributorsListSection(insight);
        } else {
          contributors = self.getContributorsListSingleLine(insight);
        }
        return !(0, _ramda.isNil)(insight) && self.renderSingleInsightCard(insight, index, contributors);
      });
    }
  }, {
    key: 'renderSingleInsightCard',
    value: function renderSingleInsightCard(insight, index, contributors) {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xlg-12', key: index },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xlg-8 padding-top-10 ' + (this.props.breakpoint < 3 ? "padding-bottom-10" : "padding-bottom-32") },
          _react2.default.createElement(
            'h3',
            { 'data-testid': 'portfolio-insight-card-subtitle', className: 'sub-header-3' },
            insight.pageTitle
          ),
          _react2.default.createElement(
            'a',
            { target: '_blank', href: insight.pageURL, 'data-testid': 'portfolio-insight-continue-reading-link',
              className: 'portfolio-insight-continue-reading-link tag',
              onClick: function onClick() {
                return _this2.trackGA(insight.pageURL);
              },
              'aria-label': 'Continue reading about ' + insight.pageTitle
            },
            _string_utility2.default.renderFormattedLabel("Continue reading", "portfolio-manager-insight-card-continue-link")
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xlg-4 padding-top-10 padding-bottom-32' },
          contributors
        )
      );
    }
  }, {
    key: 'renderPortfolioInsightImage',
    value: function renderPortfolioInsightImage(insight) {
      if (this.props.breakpoint > 3) {
        return _react2.default.createElement(
          'div',
          { className: 'col-md-2 col-lg-2 col-xlg-2 padding-top-10' },
          _react2.default.createElement(
            'a',
            { target: '_blank', href: insight.pageURL },
            _react2.default.createElement('img', { className: 'portfolio-insight-image', 'data-testid': 'portfolio-insight-image-url',
              src: this.props.gaiaRedirectUrl + '/images/portfolio_insights.svg',
              alt: this.props.intl.formatMessage({ id: "portfolio-manager-insight-card-related-reading",
                defaultMessage: "related reading" }) })
          )
        );
      } else {
        return null;
      }
    }
  }, {
    key: 'getContributorsListSingleLine',
    value: function getContributorsListSingleLine(insight) {
      var contributors = '';
      (insight.contributorName || []).map(function (contributor) {
        if (!(0, _ramda.isNil)(contributor)) {
          contributors = contributors + contributor + ', ';
        }
        return contributors;
      });
      // remove trailing space and comma
      return (0, _ramda.isEmpty)(contributors) ? contributors : _react2.default.createElement(
        'h4',
        { 'data-testid': 'portfolio-insight-contributor',
          className: 'portfolio-insight-contributor font-weight-300 font-15pt4 line-height-1pt4' },
        'By ' + contributors.substring(0, contributors.length - 2)
      );
    }
  }, {
    key: 'getContributorsListSection',
    value: function getContributorsListSection(insight) {
      var self = this;
      if ((0, _functional_utility.isNilOrEmpty)(insight.contributors)) {
        return null;
      } else {
        return _react2.default.createElement(
          'div',
          { className: 'portfolio-insight-contributor col-md-12 col-sm-12 col-xs-12 col-lg-12 col-xlg-12 tag padding-left-20 padding-vertical-0' },
          this.props.contributorsPrefixBy ? _react2.default.createElement(
            'span',
            null,
            'By '
          ) : null,
          _react2.default.createElement(
            'div',
            null,
            insight.contributors.map(function (contributor, position) {
              if (!(0, _functional_utility.isNilOrEmpty)(contributor) && !(0, _functional_utility.isNilOrEmpty)(contributor.name)) {
                var displayAuthor = contributor.name;
                if (!(0, _ramda.isNil)(contributor.contributorURL)) {
                  displayAuthor = _react2.default.createElement(
                    'a',
                    { 'data-testid': 'portfolio-insight-contributor-link',
                      href: contributor.contributorURL },
                    contributor.name
                  );
                } else {
                  displayAuthor = _react2.default.createElement(
                    'span',
                    { 'data-testid': 'portfolio-insight-contributor-name' },
                    contributor.name
                  );
                }
                return _react2.default.createElement(
                  'div',
                  { key: position, className: "insight-contributor-section" },
                  self.renderFundManagerImage(contributor),
                  _react2.default.createElement(
                    'div',
                    null,
                    displayAuthor,
                    self.getAuthorTitle(contributor)
                  )
                );
              }
            })
          )
        );
      }
    }
  }, {
    key: 'renderFundManagerImage',
    value: function renderFundManagerImage(fundManager) {
      var imageURL = this.getImageURL(fundManager);
      return _react2.default.createElement(
        'div',
        {
          className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "margin-right-0 col-xs-2 col-sm-2", "col-md-3 col-lg-3 col-xlg-3 margin-right-10") + ' ' },
        !(0, _ramda.isNil)(imageURL) && _react2.default.createElement('img', {
          className: ' ' + (0, _functional_utility.ifMobileBreakpoint)(this.props.breakpoint, "height-34 width-34", "height-50 width-50") + ' border-radius-50 fund-managers-img',
          src: imageURL, 'data-testid': 'fund-manager-image',
          alt: '' })
      );
    }
  }, {
    key: 'getImageURL',
    value: function getImageURL(fundManager) {
      var imageURL = null;
      if (!this.props.hideShadowImage) {
        imageURL = this.props.gaiaRedirectUrl + "/images/default-user-image.svg";
      }
      if (fundManager.imageURL) {
        imageURL = fundManager.imageURL;
      }
      return imageURL;
    }
  }, {
    key: 'getAuthorTitle',
    value: function getAuthorTitle(contributor) {
      if (!(0, _functional_utility.isNilOrEmpty)(contributor.functionalTitle)) {
        return _react2.default.createElement(
          'div',
          { 'data-testid': 'portfolio-insight-author-title', className: "body2" },
          contributor.functionalTitle
        );
      }
    }
  }]);

  return PortfolioInsightCard;
}(_react2.default.Component);

exports.default = PortfolioInsightCard;